<svg
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 6 14">
    <path d="M5.977 10.148c0.039 0.094 0.023 0.195-0.039 0.273l-2.734 3c-0.047 0.047-0.109 0.078-0.18 0.078v0c-0.070 0-0.141-0.031-0.187-0.078l-2.773-3c-0.062-0.078-0.078-0.18-0.039-0.273 0.039-0.086 0.125-0.148 0.227-0.148h1.75v-9.75c0-0.141 0.109-0.25 0.25-0.25h1.5c0.141 0 0.25 0.109 0.25 0.25v9.75h1.75c0.102 0 0.187 0.055 0.227 0.148z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-long-arrow-down.html